import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class UserLevelUpResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("UserLevelUpResourcePackage");
    }
    public get assets_views_user_level_up_emmiters_crowns_fly_json(): Object {
        return this.resource<Object>("assets/views/user_level_up/emmiters/crowns_fly.json");
    }
    public get assets_views_user_level_up_ui_ui_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/user_level_up/ui/ui_1x.atlas.json");
    }
    public get assets_views_user_level_up_ui_crowns_crowns_bg_png(): Texture {
        return this.assets_views_user_level_up_ui_ui_1x_atlas_json.textures["crowns/crowns_bg.png"];
    }
    public get assets_views_user_level_up_ui_tittle_lvl_up_tittle_png(): Texture {
        return this.assets_views_user_level_up_ui_ui_1x_atlas_json.textures["tittle/lvl_up_tittle.png"];
    }
    public get assets_views_user_level_up_ui_light_violet_light_png(): Texture {
        return this.assets_views_user_level_up_ui_ui_1x_atlas_json.textures["light/violet_light.png"];
    }
    public get assets_views_user_level_up_ui_reward_icons_target_png(): Texture {
        return this.assets_views_user_level_up_ui_ui_1x_atlas_json.textures["reward_icons/target.png"];
    }
    public get assets_views_user_level_up_ui_reward_icons_steal_icon_png(): Texture {
        return this.assets_views_user_level_up_ui_ui_1x_atlas_json.textures["reward_icons/steal_icon.png"];
    }
    public get assets_views_user_level_up_ui_reward_icons_wheel_icon_png(): Texture {
        return this.assets_views_user_level_up_ui_ui_1x_atlas_json.textures["reward_icons/wheel_icon.png"];
    }
    public get assets_views_user_level_up_ui_ui_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/user_level_up/ui/ui_1x.atlas.png");
    }
}

